// Jinja variable scanning for the two prompt templates.
//
// Its own module because both the inline editor (PromptEditor) and the problem list (validate.js)
// need it, and validate.js must not import a component.

// Only the bare `{{ name }}` form. A template can also write `{{ a.b }}`, a filter, or a `{% if %}`,
// and those are deliberately NOT scanned: the job is to catch an operator who typed a variable that
// does not exist for their documents kind, not to reimplement Jinja.
const TOKEN = /\{\{\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*\}\}/g;

export const templateVariables = (text) => {
  const source = String(text || '');
  const found = {};
  let match = TOKEN.exec(source);
  while (match) {
    found[match[1]] = true;
    match = TOKEN.exec(source);
  }
  TOKEN.lastIndex = 0;
  return Object.keys(found);
};

// `allowed` of null means the documents kind is not in the mirror — say nothing, rather than turn
// every variable in the prompt into a warning. Same rule as the rest of specSchema.js: a kind this
// client has never heard of is not evidence of a mistake.
export const unknownVariables = (text, allowed) =>
  allowed ? templateVariables(text).filter((v) => allowed.indexOf(v) === -1) : [];
